class ThemeGTMDatalayer extends HTMLElement {
  constructor() {
    super();

    window.dataLayer = window.dataLayer || [];

    this.state = {
      firedListItemIds: new Set()
    }

    this.setupTrackingForTemplates();
    this.setupGlobalTracking();
  }

  setupGlobalTracking() {
    this.trackMegamenuImageClick()
    this.trackMobileMenuImageClick()
    this.trackAnnouncementBarLinkClick()
  }

  setupTrackingForTemplates() {
    switch (this.dataset.template) {
      case 'product':
        this.initPdpTracking();
        break;

      case 'index':
        this.initHomeTracking();
        break;

      case 'collection':
        this.initPlpTracking();
        break;

      default:
        break;
    }
  }

  initPdpTracking() {
    this.trackTailoringServiceClick()
    this.trackSizingGuideClick()
  }

  initHomeTracking() {
    this.trackHomeSectionClicks();
  }

  initPlpTracking() {
    const trackViewItemList = this.trackViewItemList.bind(this)
    trackViewItemList()

    this.trackViewPromotion()
    this.trackSelectPromotion()

    let debounceTimer = null;
    window.addEventListener('scroll', function () {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(function () {
        trackViewItemList();
      }, 500);
    }, { passive: true });
  }

  trackViewItemList() {
    if (!window.itemListData) return;

    const self = this;

    const visibleItems = window.itemListData.items.filter(function (item) {
      const itemEl = document.querySelector(`[data-gtm-el="product-grid"] [data-gtm-item-id="${item.lookup_id}"]`)

      if (!itemEl) return false

      const isInViewport = self.isHalfElementInViewport(itemEl)
      const hasBeenFired = self.state.firedListItemIds.has(item.lookup_id)

      if (!isInViewport || hasBeenFired) return false

      self.state.firedListItemIds.add(item.lookup_id)

      return true
    });

    if (!visibleItems.length) return;

    const ga4FriendlyItems = visibleItems.map((item, index) => {
      const discount = item.compare_at_price > item.price
        ? parseFloat((item.compare_at_price - item.price).toFixed(2))
        : 0;

      return {
        item_id: item.item_id,
        item_name: item.item_name,
        discount: discount,
        index: item.index,
        item_brand: item.item_brand,
        item_category: item.item_category,
        item_list_id: window.itemListData.item_list_id,
        item_list_name: window.itemListData.item_list_name,
        item_variant: item.item_variant,
        price: item.price,
        google_business_vertical: "retail",
        quantity: 1
      };
    });

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: window.itemListData.item_list_id,
        item_list_name: window.itemListData.item_list_name,
        items: ga4FriendlyItems
      }
    });
  }

  isHalfElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    const verticalVisible = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    const horizontalVisible = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);

    const visibleArea = verticalVisible * horizontalVisible;
    const totalArea = rect.width * rect.height;

    return visibleArea / totalArea >= 0.5;
  }

  trackViewPromotion() {
    const viewedPromos = new WeakSet();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !viewedPromos.has(entry.target)) {
            viewedPromos.add(entry.target)

            dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: 'view_promotion',
              ecommerce: {
                promotion_name: entry.target.dataset.gtmPromoName,
                creative_slot: entry.target.dataset.gtmCreativeSlot,
                items: [{
                  item_name: entry.target.dataset.gtmPromoItemName
                }]
              }
            })
          }
        })
      },
      {
        threshold: 0.5,
      }
    );

    document.querySelectorAll('[data-gtm-el="promo"]').forEach((el) => {
      observer.observe(el);
    });
  }


  trackSelectPromotion() {
    document.addEventListener('click', (e) => {
      const promoEl = e.target.closest('[data-gtm-el="promo"]');

      if (!promoEl) return;

      dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'select_promotion',
        ecommerce: {
          promotion_name: promoEl.dataset.gtmPromoName,
          creative_slot: promoEl.dataset.gtmCreativeSlot,
          items: [{
            item_name: promoEl.dataset.gtmPromoItemName
          }]
        }
      });
    });
  }

  trackHomeSectionClicks() {
    const homeSectionEls = document.querySelectorAll('#page-wrapper .shopify-section');
    homeSectionEls.forEach((el, index) => {
      el.addEventListener('click', (event) => {
        const sectionText = event.currentTarget.dataset.gtmSectionText || '';

        window.dataLayer.push({
          event: 'home_section_click',
          target_index: index + 1,
        });
      });
    });
  }

  trackAnnouncementBarLinkClick() {
    const announcementBarLinks = document.querySelectorAll('[data-gtm-el="announcement-bar-link"]');

    if (announcementBarLinks.length <= 0) return;

    announcementBarLinks.forEach(linkEl => {
      linkEl.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'announcement_bar_link_click',
          target_text: linkEl.textContent.trim(),
        });
      })
    })
  }

  trackMegamenuImageClick() {
    const megamenuImageEls = document.querySelectorAll('[data-gtm-el="nav-info-block-desktop"]');

    megamenuImageEls.forEach((el) => {
      el.addEventListener('click', (event) => {
        const targetText = event.currentTarget.dataset.gtmTargetText;
        const targetContext = event.currentTarget.dataset.gtmTargetContext;

        window.dataLayer.push({
          event: 'nav_image_click_desktop',
          target_text: targetText,
          target_context: targetContext,
        });
      });
    })
  }

  trackMobileMenuImageClick() {
    const mobileMenuImageEls = document.querySelectorAll('[data-gtm-el="nav-info-block-mobile"]');

    mobileMenuImageEls.forEach((el) => {
      el.addEventListener('click', (event) => {
        const targetText = event.currentTarget.dataset.gtmTargetText;
        const targetContext = event.currentTarget.dataset.gtmTargetContext;

        window.dataLayer.push({
          event: 'nav_image_click_mobile',
          target_text: targetText,
          target_context: targetContext,
        });
      });
    })
  }

  trackTailoringServiceClick() {
    const tailoringServiceEl = document.querySelector('[data-gtm-el="pdp-tailoring-service"]');

    if (!tailoringServiceEl) return

    tailoringServiceEl.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'pdp_tailoring_service_click',
      });
    });
  }

  trackSizingGuideClick() {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const nodeHasClass = node.classList.contains('ks-chart-modal-link')

            if (nodeHasClass) {
              const sizingGuideEl = nodeHasClass ? node : descendantWithClass;

              sizingGuideEl.addEventListener('click', () => {
                window.dataLayer.push({
                  event: 'pdp_sizing_guide_click',
                });
              });

              observer.disconnect();
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}

customElements.define('theme-gtm-datalayer', ThemeGTMDatalayer)
